import PageMeta from '../common/PageMeta.tsx'
import PageBreadcrumb from '../common/PageBreadCrumb.tsx'
import { ReactNode } from 'react'

export interface PageProps {
	children?: ReactNode
	title: string
	breadcrumbs?: string
	description?: string
}

export const Page = ({ children, title, breadcrumbs, description }: PageProps) => {
	return (
		<>
			<PageMeta title={`${title} | Nextpeak`} description={description ?? 'title page'} />
			{breadcrumbs && <PageBreadcrumb pageTitle={breadcrumbs} />}
			{children}
		</>
	)
}
